if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.previousButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');

        /* ModalDialog closes media modals on pointerup. Stop events from
           inside the dialog so only clicks on the outside overlay close it. */
        this.dialog?.addEventListener('pointerup', (event) => event.stopPropagation());

        this.addEventListener('click', (event) => {
          if (this.dialog && !this.dialog.contains(event.target)) {
            this.hide();
          }
        });

        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', () => this.changeSlide(-1));
        this.nextButton?.addEventListener('click', () => this.changeSlide(1));

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowLeft') this.changeSlide(-1);
          if (event.code === 'ArrowRight') this.changeSlide(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        if (window.matchMedia('(max-width: 749px)').matches) return;

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeSlide = activeMedia?.closest('.product-media-modal__slide');
        const slides = this.getSlides();
        const content = this.querySelector('.product-media-modal__content');

        content?.removeAttribute('data-slide-direction');
        slides.forEach((slide) => slide.classList.toggle('active', slide === activeSlide));
        if (!activeMedia || !activeSlide) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.updateNavigation();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      getSlides() {
        return Array.from(this.querySelectorAll('.product-media-modal__slide'));
      }

      changeSlide(direction) {
        const slides = this.getSlides();
        if (slides.length < 2) return;

        let currentIndex = slides.findIndex((slide) => slide.classList.contains('active'));
        if (currentIndex < 0) currentIndex = 0;

        const nextIndex = (currentIndex + direction + slides.length) % slides.length;
        const content = this.querySelector('.product-media-modal__content');
        content?.setAttribute('data-slide-direction', direction > 0 ? 'next' : 'previous');

        slides[currentIndex].classList.remove('active');
        slides[nextIndex].classList.add('active');

        window.pauseAllMedia();
        const nextMedia = slides[nextIndex].querySelector('[data-media-id]');
        if (nextMedia?.nodeName === 'DEFERRED-MEDIA') nextMedia.loadContent();

        this.updateNavigation();
      }

      updateNavigation() {
        const hasMultipleSlides = this.getSlides().length > 1;
        if (this.previousButton) this.previousButton.hidden = !hasMultipleSlides;
        if (this.nextButton) this.nextButton.hidden = !hasMultipleSlides;
      }
    }
  );
}
